import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { LoaderCircle } from 'rhinostyle';
import EmptyMessage from './EmptyMessage';

// Temporary or actual imports for route components
import RhinoVoipContainer from './RhinoVoipContainer';
import RhinoVOIPFax from './RhinoVOIPFax';

const RhinoVOIP = () => {
  const { pageId } = useParams();
  const [loading, setLoading] = useState(true);
  const [authToken] = useState(null);
  const organizationId = useSelector((state) => state.auth.currentOrg);

  useEffect(() => {
    setLoading(false);
  }, [organizationId]);

  const voipLoader = (
    <div className="app-page-loader-outer">
      <div className="app-page-loader">
        <LoaderCircle size="large" className="u-text-primary" />
      </div>
    </div>
  );

  const componentsByRoute = {
    dashboard: RhinoVoipContainer,
    fax: RhinoVOIPFax,
  };

  const SelectedComponent = componentsByRoute[pageId] || RhinoVoipContainer;

  let content;
  if (loading) {
    content = voipLoader;
  } else if (!authToken) {
    content = <SelectedComponent authToken={authToken} />;
  } else {
    content = <EmptyMessage />;
  }

  return (
    <div className="app-page__container">
      <div className="rhinophone-iframe__wrapper">
        {content}
      </div>
    </div>
  );
};

export default RhinoVOIP;
